export const faqNav = [
    {label: "Личный кабинет WAY2WEI", value: "mainBlock"},
    {label: "Регистрация и вход", value: "authBlock"},
    {label: "Сотрудники и группы", value: "staffGroupsBlock"},
    {label: "Оценка и развитие", value: "assessmentDevBlock"},
    {label: "Управление доступами", value: "accessControlBlock"},
    {label: "Работа с заказами", value: "ordersBlock"},
    {label: "Настройка уведомлений", value: "notificationsBlock"},
    {
        label: "Отчёты и аналитика",
        value: "reportsRoot",
        children: [
            { label: "Сотрудники и группы", anchor: "reports-staff-groups" },
            { label: "Оценка и развитие", anchor: "reports-assessment" },
            { label: "Финансовые отчёты", anchor: "reports-finance" },
        ],
    },
    {label: "Финансовые операции", value: "financeBlock"},
    {label: "Настройки аккаунта", value: "accountSettingsBlock"},
    {label: "Поддержка и помощь", value: "supportBlock"},
];